export var OAuthType;
(function (OAuthType) {
    OAuthType["GITHUB"] = "GITHUB";
    OAuthType["FACEBOOK"] = "FACEBOOK";
    OAuthType["GOOGLE"] = "GOOGLE";
})(OAuthType || (OAuthType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/core/domain/authorize/oauthType.ts
// module id = 313
// module chunks = 50